import { setFulfilled, setPending, setRejected } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import { SuggestedTopicsLoadAction } from '../../domains/suggestedTopics/loadActions.types';
import { SuggestedTopicsLoadMoreAction } from '../../domains/suggestedTopics/loadMoreActions.types';

import { ViewerSuggestedTopics } from './types';

export const initialState: ViewerSuggestedTopics = {
  pending: false,
  fulfilled: undefined,
  rejected: undefined,
};

const loadMoreSuggestedTopicFulfilled = (
  state: ViewerSuggestedTopics,
  viewerSuggestedTopics: { readonly suggestedTopicIds: string[] }
) =>
  setFulfilled({
    suggestedTopicIds: [
      ...new Set([...(state.fulfilled?.suggestedTopicIds || []), ...viewerSuggestedTopics.suggestedTopicIds]),
    ],
  });

export type SuggestedTopicsAction = SuggestedTopicsLoadAction | SuggestedTopicsLoadMoreAction;

const reducer: Reducer<ViewerSuggestedTopics, SuggestedTopicsAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'SUGGESTED_TOPICS.LOAD_PENDING':
      return setPending();
    case 'SUGGESTED_TOPICS.LOAD_FULFILLED':
      return setFulfilled(action.payload.entities.viewerSuggestedTopics);
    case 'SUGGESTED_TOPICS.LOAD_REJECTED':
      return setRejected(action.payload.error);
    case 'SUGGESTED_TOPICS.LOAD_MORE_FULFILLED':
      return loadMoreSuggestedTopicFulfilled(state, action.payload.entities.viewerSuggestedTopics);
    default:
      return state;
  }
};

export default reducer;
